// extracted by mini-css-extract-plugin
export default {"moreButtonContainer":"_3oQOA","moreButton":"_2bKu3","openButton":"_7zeR2","arrow":"_23kSI","arrowUp":"zlIQQ","actionText":"yALri","dropdown":"_2YRnR"};